import type { ZoomBookingMember } from '@nrx/booking-ui';

import type { ConsultMemberDetails } from '../exchange/exchange-types.js';

/**
 * Adapts the exchange's optional member identity into the shape `ZoomBookingFrame` requires.
 *
 * @remarks Unlike ffs-signup, the magic-link exchange may resolve no member at all — falls back to
 * empty strings, which Zoom simply leaves unprefilled (the same experience the vendor's plain
 * link-out gave every member, since it never carried prefill data either). `phone` stays omitted
 * rather than set to `undefined` — see `buildBookingUrl`.
 */
export function toZoomBookingMember(member: ConsultMemberDetails | null): ZoomBookingMember {
  return {
    email: member?.email ?? '',
    firstName: member?.firstName ?? '',
    lastName: member?.lastName ?? '',
    ...(member?.phone !== undefined ? { phone: member.phone } : {}),
  };
}
